import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'

import { getComment } from 'data/comments/selectors'
import { getAllUsers } from 'data/users/selectors'
import { selectors as ThreadsSelectors } from 'data/threads'

import CommentWrapper from '../CommentWrapper'
import Scrollable from 'components/Utils/Scrollable'
import MainHeader from './Header'
import ThreadCreator from '../../Thread/ThreadCreator'
import ArchivedThreadsPlaceholder from './ArchivedThreadsPlaceholder'
import Banner from '../Banner'

import { renderDate, getCommentsWithAfterBefore } from '../../utils'

class MainPanel extends Component {
  state = {
    scrolling: false,
    showArchivedThreads: false,
  }

  static propTypes = {
    noteId: PropTypes.string.isRequired,
    goToThreadPanel: PropTypes.func,
    items: PropTypes.instanceOf(List).isRequired,
  }
  componentDidMount() {
    if (this.props.activeThread && this.props.activeThread.resolvedAt) {
      this.props.setState({ showArchivedThreads: true })
    }
  }

  componentWillReceiveProps({ activeThread, activeThreadId }) {
    if (activeThread && activeThreadId !== this.props.activeThreadId) {
      this.props.setState({ showArchivedThreads: !!activeThread.resolvedAt })
    }
  }

  onScrollingStatusChange = scrolling => {
    this.setState({ scrolling })
  }

  renderComments = () => {
    const { items, goToThreadPanel, noteId } = this.props
    const { showArchivedThreads } = this.state

    const filteredItems = items.filter(
      ({ thread, comment }) =>
        comment && (showArchivedThreads ? true : !thread.resolvedAt)
    )
    const commentsWithAfterBefore = getCommentsWithAfterBefore({
      comments: filteredItems.map(i => i.comment),
    })
    const itemsEnriched = filteredItems.map((item, index) => {
      const comment = commentsWithAfterBefore
        .filter(c => c.comment.id === item.comment.id)
        .first()

      let sameAuthorBefore = comment.sameAuthorBefore
      if (sameAuthorBefore) {
        //If you post two messages, your pic doesn't appear on the second unless
        // - the first message has replies
        // - the second has replies
        // - the second has an highlight (inline comment)
        const previousThread = filteredItems.get(index - 1)
        const currentThread = item
        sameAuthorBefore =
          !currentThread.thread.highlight &&
          previousThread.numberOfReplies === 0 &&
          currentThread.numberOfReplies === 0
      }

      return {
        ...item,
        sameAuthorBefore,
        sameAuthorAfter: comment.sameAuthorAfter,
      }
    })

    let previousDate = null
    return (
      <div className="flexbox flexbox-align-start flexbox-column">
        {itemsEnriched.map((row, index) => {
          const rowToRender = (
            <React.Fragment key={row.comment.id}>
              {renderDate(row.thread.createdAt, previousDate)}

              <CommentWrapper
                key={row.comment.id}
                index={index}
                isMainPanel
                comment={row.comment}
                sameAuthorBefore={row.sameAuthorBefore}
                sameAuthorAfter={row.sameAuthorAfter}
                isResolved={!!row.thread.resolvedAt}
                numberOfReplies={row.numberOfReplies}
                repliers={row.repliers}
                highlight={row.thread.highlight}
                onReply={() => {
                  goToThreadPanel(row.thread.id)
                }}
                noteId={noteId}
              />
            </React.Fragment>
          )

          previousDate = row.thread.createdAt
          return rowToRender
        })}
      </div>
    )
  }

  render() {
    const { noteId, items } = this.props
    const { showArchivedThreads } = this.state

    return (
      <div className="flexbox flexbox-column width-full height-full">
        <MainHeader
          setShowArchivedThreads={showArchivedThreads =>
            this.setState({ showArchivedThreads })
          }
          showArchivedThreads={showArchivedThreads}
          noteId={noteId}
          scrolling={this.state.scrolling}
        />
        <Banner
          show={this.props.showBanner}
          onCloseBanner={this.props.onCloseBanner}
        />
        <Scrollable
          ref={ref => (this.scrollableRef = ref)}
          bottomOnLoad
          innerClassName="flexbox flexbox-column flexbox-grow"
          onScrollingChange={this.onScrollingStatusChange}
          style={{ height: 'calc(100vh - 62px)' }}
        >
          <div className="padding-bottom-normal">
            {items.filter(i => !!i.thread.resolvedAt).size === 0 &&
            showArchivedThreads ? (
              <ArchivedThreadsPlaceholder />
            ) : (
              this.renderComments()
            )}
            <ThreadCreator noteId={noteId} />
          </div>
        </Scrollable>
      </div>
    )
  }
}

const mapStateToProps = (state, { noteId }) => {
  const allUsers = getAllUsers(state)
  const threads = ThreadsSelectors.getCurrentNoteThreads(state, noteId).sort(
    (t1, t2) => new Date(t1.createdAt) - new Date(t2.createdAt)
  )

  const items = threads.map(thread => {
    const commentIds = thread.comments.map(c => c.get('id')).toSet()
    const threadComments = commentIds
      .map(id => getComment(state, id))
      .filter(c => !!c) // when deleting a reply there can be a race condition where thread.commentIds contain comments not in the state anymore
      .sortBy(c => new Date(c.createdAt).getTime())
      .toList()
    const repliers = threadComments
      .map(t => t.createdBy)
      .toSet()
      .toArray() // toset.toArray allow to remove duplicates
      .map(userId => allUsers.get(userId))
      .filter(u => !!u) //deleted users are not here, let'sfilter the "undefined"
    return {
      comment: threadComments.get(0),
      thread,
      numberOfReplies: threadComments.size - 1,
      repliers,
    }
  })
  return { items }
}

export default connect(mapStateToProps)(MainPanel)
